import { InjectionToken } from "@angular/core";
import { Consent } from "./consent.model";

export const CONSENT = new InjectionToken<Consent>('CONSENT');
